import React from "react";
import { Tooltip, Box, Chip } from "@mui/material";
import { MdFmdGood } from "react-icons/md";
import RoomIcon from '@mui/icons-material/Room';
const SpecialistMapMarker = ({ selectHandler, practice, selectable }) => {
  const [hover, onHover] = React.useState(false);
  return (
    <div
      className="map-marker"
      onClick={(e) => selectable && selectHandler(practice)}
      onMouseEnter={() => !hover && onHover(true)}
      onMouseLeave={() => hover && onHover(false)}
    >
      <Tooltip
        className="map-tooltip"
        disableFocusListener
        title={
          <Box>
            {hover && (
              <div>
                <b>{ practice.name }</b>
                <br />
                <b>{ practice.address }</b>
              </div>
            )}
          </Box>
        }
      >
        <div>
          <RoomIcon fontSize='large' color='success' />
        </div>
      </Tooltip>
    </div>
  );
};

export default SpecialistMapMarker;
